module.exports = __webpack_public_path__ + "static/media/3.a2b05836.jpg";